jQuery(function(){

    jQuery(document).on('change', '.image-cards__filter', function(e){
        var $this = jQuery(this);
        var filter = $this.val();
        var $option = $this.find(':selected');
        var container = $option.data('container');
        var fragment = $option.data('fragment');
        var $container = jQuery(container);
        var url = window.location.href.split('?')[0];
        url = url + '?filter=' + filter;


        $container.addClass('pjax-container--hide');
        jQuery('.paginator__next-link').removeClass('paginator__next-link--disabled');

        jQuery(document).one('pjax:success', function () {
            var pages = jQuery('input[name="image_cards_total_pages"]').val();
            jQuery('.paginator__number-of-pages').html(pages);
            //console.log("start" + pages);

              if (jQuery("#image-cards-container").length > 0) {
                  var currentPageImage = jQuery("input[name=image_cards_next]").val();
                  var totalPageImage = jQuery("input[name=image_cards_total_pages]").val();
                  if (totalPageImage == 1) {
                      jQuery("input[name=p]").val(currentPageImage);
                      jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
                      jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
                    }
                    else if (totalPageImage == 0) {
                        jQuery("input[name=p]").val(totalPageImage);
                        jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
                        jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
                    }
                else {
                    jQuery("input[name=p]").val(currentPageImage - 1);
                }
              }

              if (jQuery("#deal-cards-container").length > 0) {
                  var currentPageDeal = jQuery("input[name=deal_cards_next]").val();
                  var totalPageDeal = jQuery("input[name=deal_cards_total_pages]").val();
                  if (totalPageDeal == 1) {
                  jQuery("input[name=p]").val(currentPageDeal);
                  jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
                  jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
                  }
                  else if (totalPageDeal == 0) {
                    jQuery("input[name=p]").val(totalPageDeal);
                    jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
                    jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
                  }
                  else{
                    jQuery("input[name=p]").val(currentPageDeal + 1);
                  }
              }

        });

        jQuery(document).one('pjax:complete', function(){


            $container.removeClass('pjax-container--hide');
            jQuery('input[name="p"]').val(1);

            jQuery('.paginator__content').find('form').attr('data-total-pages', pages);

            var pages = jQuery('input[name="image_cards_total_pages"]').val();

            // jQuery('.paginator__number-of-pages').html(pages);

            if(pages == 1 || jQuery("input[name=p]").val() == pages) {
                jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
            }

            if(jQuery("input[name=p]").val() < pages) {
                jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
            }

            jQuery('.paginator__next-link').attr('href', '?p=' + jQuery('input[name="image_cards_next"]').val() + '&filter=' + filter);
            jQuery('.paginator__previous-link').attr('href', '?p=' + jQuery('input[name="image_cards_previous"]').val() + '&filter=' + filter);

            jQuery('.paginator__container').find('.paginator__previous-link').attr('data-page', jQuery('input[name="deal_cards_previous"]').val());
            jQuery('.paginator__container').find('.paginator__next-link').attr('data-page', jQuery('input[name="deal_cards_next"]').val());
        });

        $container.one('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function(){
            jQuery.pjax({container: container, fragment: fragment, scrollTo: false, url: url});
        });
    });
});